module.exports = __webpack_public_path__ + "img/9788972979371.f6bde8e8.jpg";